import {useState} from "react";
import {twMerge} from "tailwind-merge";
import {toast} from "react-toastify";

export default function SingleDropdownTree({
                                               data = [],
                                               selectedLabel = "",
                                               label = "",
                                               onSelect,
                                               rowLabel = true,
                                               classes = {}
                                           }) {

    const [showDropDown, setShowDropDown] = useState(false);
    const {labelClasses} = classes;

    const collapseHandler = ({target}) => {
        const subListEl = target.nextElementSibling;
        if(!subListEl) {
            //children is empty []
            if(target.classList.contains("collapsed-node")) {
                target.classList.remove("collapsed-node");
                toast.warn("آیتم مورد نظر خالیست")
            } else {
                target.classList.add("collapsed-node");
            }
            return;
        }

        if (subListEl.classList.contains("sub-list")) {
            if (subListEl.classList.contains("collapsed")) {
                subListEl.classList.remove("collapsed");
                target.classList.remove("collapsed-node");
            } else {
                subListEl.classList.add("collapsed");
                target.classList.add("collapsed-node");
            }
        }
    }

    const selectHandler = (firstNode, secondNode) => {
        setShowDropDown(false);
        onSelect({firstNode, secondNode});
    }

    return (

        <div className={`w-full ${rowLabel ? "flex" : ""}`}>
            {
                label ?
                    <p className={twMerge(`text-sm text-pol-gray ${rowLabel ? "mb-2 mr-4 xl:ml-4 xl:mb-0 xl:mr-0" : "mb-2 mr-4"}`, labelClasses)}>
                        {label}
                    </p>
                    : null
            }
            <div className="relative flex-grow">
                <div
                    className={`w-screen h-screen fixed left-0 top-0 z-20 ${showDropDown ? "" : "hidden"}`}
                    onClick={() => setShowDropDown(false)}/>

                <button
                    onClick={() => setShowDropDown(true)}
                    type="button"
                    className="w-full rounded-2xl bg-pol-light-3 px-3.5 py-2.5 border border-pol-gray-light-3 flex items-center justify-between text-pol-dark-800">
                    <p>{selectedLabel}</p>
                    <i className="icon-simple-arrow-left block -rotate-90 text-sm"/>
                </button>
                <div
                    className={`absolute z-20 flex flex-col w-full h-[18.125rem] bg-white rounded-2xl top-0 left-0 shadow-[0_0_9px_11px_rgba(142,130,180,0.06)] pr-4 pl-2 pt-4 pb-3.5 ${showDropDown ? "" : "hidden"}`}>

                    <div className="pb-4 border-b border-b-pol-light text-pol-light-brown font-semibold">
                        {selectedLabel}
                    </div>
                    <ul className="pol-single-dropdown-tree flex-grow overflow-y-auto pol-scroll mt-2.5 space-y-6 pr-2.5">
                        {data.map(firstNode => (
                            <li key={firstNode.value}>
                                <button
                                    type="button"
                                    className="text-pol-dark font-bold text-sm mb-6 collapsed-node"
                                    onClick={collapseHandler}
                                >
                                    <i className="icon-left-arrow text-xs ml-3.5 -rotate-90 inline-block pointer-events-none duration-200"/>
                                    <span className="pointer-events-none">{firstNode.label}</span>
                                </button>
                                {
                                    firstNode.children.length ?
                                        <ul className="space-y-6 pr-6 sub-list collapsed">
                                            {
                                                firstNode.children.map(secondNode => (
                                                    <li key={secondNode.value}>
                                                        <button
                                                            onClick={() => selectHandler(firstNode, secondNode)}
                                                            type="button"
                                                            className="text-pol-dark-800 text-sm font-semibold">{secondNode.label}</button>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                        : null
                                }
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
        // :
        // <ul className="pol-single-dropdown-tree flex-grow overflow-y-auto pol-scroll mt-2.5 space-y-6 pr-2.5">
        //     {data.map(firstNode => (
        //         <li key={firstNode.value}>
        //             <button
        //                 type="button"
        //                 className="text-pol-dark font-bold text-sm mb-6 collapsed-node"
        //                 onClick={collapseHandler}
        //             >
        //                 <i className="icon-simple-arrow-left text-xs ml-3.5 -rotate-90 inline-block pointer-events-none duration-200"/>
        //                 <span className="pointer-events-none">{firstNode.label}</span>
        //             </button>
        //             {
        //                 firstNode.children.length ?
        //                     <ul className="space-y-6 pr-6 sub-list collapsed">
        //                         {
        //                             firstNode.children.map(secondNode => (
        //                                 <li key={secondNode.value}>
        //                                     <button
        //                                         onClick={() => selectHandler(firstNode, secondNode)}
        //                                         type="button"
        //                                         className="text-pol-dark-800 text-sm font-semibold">{secondNode.label}</button>
        //                                 </li>
        //                             ))
        //                         }
        //                     </ul>
        //                     : null
        //             }
        //         </li>
        //     ))}
        // </ul>


    )
}
